<template>
    <div class="signTable">
        <template v-if="enrolInfo.enrollTitle">
            <h3 v-if="enrolInfo.enrollTitle">{{ enrolInfo.enrollTitle }}</h3>
        </template>
        <template v-else="enrolInfo.examTitle">
            <h3>{{ enrolInfo.examTitle }}</h3>
        </template>

        <div class="postName" v-if="enrolInfo.postName">申请岗位:{{enrolInfo.postName}}</div>
        <!-- 基础内容 -->
        <el-form ref="signForm" :model="info" :disabled="disabled">
            <table>
                <tbody>
                    <tr>
                        <td>
                            姓名
                        </td>
                        <td colspan="2">
                            <el-form-item
                                label="姓名"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="fullName"
                            >
                                <el-input
                                    v-model="info.fullName"
                                    readonly
                                    :title="info.fullName"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            性别
                        </td>
                        <td>
                            <el-form-item
                                label="性别"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="gender"
                            >
                                <el-select v-model="info.gender" disabled>
                                    <el-option
                                        label="男"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="女"
                                        :value="2"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            民族
                        </td>
                        <td colspan="3">
                            <el-form-item
                                label="民族"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                prop="nation"
                            >
                                <el-input
                                    v-model="info.nation"
                                    :title="info.nation"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td rowspan="4" width="140px">
                            <el-form-item
                                label="近期免冠照"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="photograph"
                                class="photograph"
                            >
                                <el-input class="photograph-input"></el-input>
                                <el-upload
                                    class="photograph-upload"
                                    with-credentials
                                    :data="{ type: 1 }"
                                    accept="image/*"
                                    :show-file-list="false"
                                    :action="uploadBaseUrl"
                                    :on-success="
                                        uploadSetFields('photograph', 1, 'info')
                                    "
                                    :on-remove="
                                        uploadSetFields('photograph', 1, 'info')
                                    "
                                >
                                    <i v-if="info.photograph === ''"
                                        >上传近期免冠照(110*160)</i
                                    >

                                    <img
                                        :src="getUrl(info.photograph)"
                                        alt=""
                                        v-else
                                    />
                                </el-upload>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            出生年月
                        </td>
                        <td colspan="2">
                            <el-form-item
                                label="出生年月"
                                prop="birthday"
                                hidden-label
                                hiddenErrorText
                                required
                            >
                                <el-date-picker
                                    disabled
                                    v-model="info.birthday"
                                    value-format="yyyy-MM-dd"
                                    :title="info.birthday"
                                ></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            籍贯
                        </td>
                        <td>
                            <el-form-item
                                label="籍贯"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                prop="origo"
                            >
                                <el-input
                                    v-model="info.origo"
                                    :title="info.origo"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            婚姻状况
                        </td>
                        <td colspan="3">
                            <el-form-item
                                label="婚姻状况"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 30 }"
                                prop="birthPlace"
                            >
                                <el-input
                                    v-model="info.birthPlace"
                                    :title="info.birthPlace"
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            户口所在地
                        </td>
                        <td colspan="2">
                            <el-form-item
                                label="户口所在地"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 40 }"
                                prop="domicilePlace"
                            >
                                <el-input
                                    v-model="info.domicilePlace"
                                    :title="info.domicilePlace"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            政治面貌
                        </td>
                        <td>
                            <el-form-item
                                label="政治面貌"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                prop="politicalStatus"
                            >
                                <el-input
                                    v-model="info.politicalStatus"
                                    :title="info.politicalStatus"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            身份证
                        </td>
                        <td colspan="3">
                            <el-form-item
                                label="身份证号码"
                                hidden-label
                                hiddenErrorText
                                prop="idNumber"
                                required
                                :rules="{ type: 'idcard' }"
                            >
                                <el-input
                                    v-model="info.idNumber"
                                    :title="info.idNumber"
                                    readonly
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            身高(cm)
                        </td>
                        <td colspan="2">
                            <el-form-item
                                label="身高"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="height"
                                :rules="{ type: 'integer', max: 3 }"
                            >
                                <el-input
                                    type="number"
                                    v-model="info.height"
                                    v-number-only
                                    :title="info.height"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            体重(kg)
                        </td>
                        <td>
                            <el-form-item
                                label="体重"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="weight"
                                :rules="{ type: 'integer', max: 3 }"
                            >
                                <el-input
                                    type="number"
                                    v-model="info.weight"
                                    :title="info.weight"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            档案保管单位
                        </td>
                        <td colspan="3">
                            <el-form-item
                                label="档案保管单位"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 50 }"
                                prop="health"
                            >
                                <el-input
                                    v-model="info.health"
                                    :title="info.health"
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            第一学历
                        </td>
                        <td>
                            <el-form-item
                                label="第一学历"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="firstQualifications"
                            >
                                <el-select
                                    v-model="info.firstQualifications"
                                    :title="info.firstQualifications"
                                >
                                    <el-option
                                        label="博士研究生"
                                        value="博士研究生"
                                    ></el-option>
                                    <el-option
                                        label="硕士研究生"
                                        value="硕士研究生"
                                    ></el-option>
                                    <el-option
                                        label="本科"
                                        value="本科"
                                    ></el-option>
                                    <el-option
                                        label="大专"
                                        value="大专"
                                    ></el-option>
                                    <el-option
                                        label="其他"
                                        value="其他"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>

                        <td>
                            学历性质
                        </td>
                        <td>
                            <el-form-item
                                label="学历性质"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="firstQualificationsProperty"
                            >
                                <el-select
                                    v-model="info.firstQualificationsProperty"
                                    :title="info.firstQualificationsProperty"
                                >
                                    <el-option
                                        label="全日制"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="自考"
                                        :value="2"
                                    ></el-option>
                                    <el-option
                                        label="函授"
                                        :value="3"
                                    ></el-option>
                                    <el-option
                                        label="其他"
                                        :value="4"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td>
                            毕业学校
                        </td>
                        <td>
                            <el-form-item
                                label="第一学历毕业学校"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 20 }"
                                prop="firstQualificationSchools"
                            >
                                <el-input
                                    v-model="info.firstQualificationSchools"
                                    :title="info.firstQualificationSchools"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            专业
                        </td>
                        <td>
                            <el-form-item
                                label="第一学历专业"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 30 }"
                                prop="firstQualificationMajors"
                            >
                                <el-input
                                    v-model="info.firstQualificationMajors"
                                    :title="info.firstQualificationMajors"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            毕业时间
                        </td>
                        <td>
                            <el-form-item
                                label="毕业时间"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="firstQualificationGraduationTime"
                            >
                                <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="
                                        info.firstQualificationGraduationTime
                                    "
                                    :title="
                                        info.firstQualificationGraduationTime
                                    "
                                ></el-date-picker>
                            </el-form-item>
                        </td>
                    </tr>
                    <tr v-if="info.firstQualificationsProperty === 4">
                        <td>
                            学历性质说明:
                        </td>
                        <td colspan="9">
                            <el-form-item
                                label="学历性质说明"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 20 }"
                                prop="firstQualificationsPropertyDesc"
                            >
                                <el-input
                                    v-model="
                                        info.firstQualificationsPropertyDesc
                                    "
                                    :title="
                                        info.firstQualificationsPropertyDesc
                                    "
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            最高学历
                        </td>
                        <td>
                            <el-form-item
                                label="最高学历"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="highestQualification"
                            >
                                <el-select
                                    v-model="info.highestQualification"
                                    :title="info.highestQualification"
                                >
                                    <el-option
                                        label="博士研究生"
                                        value="博士研究生"
                                    ></el-option>
                                    <el-option
                                        label="硕士研究生"
                                        value="硕士研究生"
                                    ></el-option>
                                    <el-option
                                        label="本科"
                                        value="本科"
                                    ></el-option>
                                    <el-option
                                        label="大专"
                                        value="大专"
                                    ></el-option>
                                    <el-option
                                        label="其他"
                                        value="其他"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>

                        <td>
                            学历性质
                        </td>
                        <td>
                            <el-form-item
                                label="学历性质"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="highestQualificationsProperty"
                            >
                                <el-select
                                    v-model="info.highestQualificationsProperty"
                                    :title="info.highestQualificationsProperty"
                                >
                                    <el-option
                                        label="全日制"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="自考"
                                        :value="2"
                                    ></el-option>
                                    <el-option
                                        label="函授"
                                        :value="3"
                                    ></el-option>
                                    <el-option
                                        label="其他"
                                        :value="4"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>

                        <td>
                            毕业学校
                        </td>
                        <td>
                            <el-form-item
                                label="最高学历毕业学校"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 20 }"
                                prop="highestQualificationSchools"
                            >
                                <el-input
                                    v-model="info.highestQualificationSchools"
                                    :title="info.highestQualificationSchools"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            专业
                        </td>
                        <td>
                            <el-form-item
                                label="最高学历专业"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 30 }"
                                prop="highestQualificationMajors"
                            >
                                <el-input
                                    v-model="info.highestQualificationMajors"
                                    :title="info.highestQualificationMajors"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            毕业时间
                        </td>
                        <td>
                            <el-form-item
                                label="毕业时间"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="highestQualificationGraduationTime"
                            >
                                <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="
                                        info.highestQualificationGraduationTime
                                    "
                                    :title="
                                        info.highestQualificationGraduationTime
                                    "
                                ></el-date-picker>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr v-if="info.highestQualificationsProperty === 4">
                        <td>
                            学历性质说明:
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="学历性质说明"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 20 }"
                                prop="highestQualificationsPropertyDesc"
                            >
                                <el-input
                                    v-model="
                                        info.highestQualificationsPropertyDesc
                                    "
                                    :title="
                                        info.highestQualificationsPropertyDesc
                                    "
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            职称、执（职）业资格及取得时间
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="职称、执（职）业资格及取得时间"
                                hidden-label
                                hiddenErrorText
                                :rules="{ max: 500 }"
                            >
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 4 }"
                                    v-model="info.certificate"
                                    :title="info.certificate"
                                    maxlength="500"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            有何特长
                        </td>
                        <td colspan="4">
                            <el-form-item
                                label="有何特长"
                                hidden-label
                                hiddenErrorText
                                prop="foreignLanguage"
                                :rules="{ max: 100 }"
                            >
                                <el-input
                                    v-model="info.foreignLanguage"
                                    :title="info.foreignLanguage"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            是否有驾照
                        </td>
                        <td colspan="5">
                            <el-form-item
                                label="是否有驾照"
                                hidden-label
                                hiddenErrorText
                                required
                                prop="drivingLicense"
                            >
                                <el-select
                                    v-model="info.drivingLicense"
                                    :title="info.drivingLicense"
                                >
                                    <el-option
                                        label="有"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="无"
                                        :value="2"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            通信地址
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="通信地址"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 50 }"
                                prop="address"
                            >
                                <el-input
                                    v-model="info.address"
                                    :title="info.address"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <!-- <td>
              邮政编码
            </td>
            <td>
              <el-form-item
                label="邮政编码"
                hidden-label
                hiddenErrorText
                required
                prop="postCode"
              >
                <el-input v-model="info.postCode"></el-input>
              </el-form-item>
            </td> -->
                    </tr>

                    <tr>
                        <td>
                            手机及固定电话号码
                        </td>
                        <td colspan="4">
                            <el-form-item
                                label="手机及固定电话号码"
                                hidden-label
                                hiddenErrorText
                                :rules="{ type: 'phone', max: 11 }"
                                prop="phone"
                            >
                                <el-input
                                    v-model="info.phone"
                                    :title="info.phone"
                                    maxlength="11"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            电子邮箱
                        </td>
                        <td colspan="5">
                            <el-form-item
                                label="电子邮箱"
                                hidden-label
                                hiddenErrorText
                                :rules="{ type: 'email', max: 50 }"
                                prop="email"
                            >
                                <el-input
                                    v-model="info.email"
                                    :title="info.email"
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            其他联系人
                        </td>
                        <td colspan="4">
                            <el-form-item
                                label="其他联系人"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                prop="otherLinkman"
                            >
                                <el-input
                                    v-model="info.otherLinkman"
                                    :title="info.otherLinkman"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            其他联系人号码
                        </td>
                        <td colspan="5">
                            <el-form-item
                                label="其他联系人号码"
                                hidden-label
                                hiddenErrorText
                                :rules="{ type: 'phone', max: 11 }"
                                prop="otherLinkmanPhone"
                            >
                                <el-input
                                    v-model="info.otherLinkmanPhone"
                                    :title="info.otherLinkmanPhone"
                                    maxlength="11"
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            工作年限(年)
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="工作年限"
                                hidden-label
                                hiddenErrorText
                                prop="workExperience"
                                required
                                :rules="{ type: 'integer' }"
                            >
                                <el-select
                                    v-model="info.workExperience"
                                    filterable
                                >
                                    <el-option
                                        :label="item + '年'"
                                        v-for="item in 40"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td
                            :rowspan="info.workHistory.length + 1"
                            class="addRowPanel"
                            style="width:140px;"
                        >
                            工作经历
                            <p>(从最近工作经历写起)</p>
                            <span
                                v-if="!disabled"
                                class="addRow"
                                @click="addRow('workHistory')"
                                >增行</span
                            >
                        </td>
                        <td class="title">开始时间</td>
                        <td>结束时间</td>
                        <td>工作年限</td>
                        <td>工作单位</td>
                        <td>工作职位</td>
                        <td colspan="2" style="width:500px;">工作内容</td>
                        <td>工作状态</td>
                        <td>证明人</td>
                        <td>证明人联系方式</td>
                    </tr>

                    <tr
                        v-for="(work, $index) in info.workHistory"
                        class="eidtItem"
                    >
                        <td>
                            <el-form-item
                                label="开始时间"
                                hidden-label
                                hiddenErrorText
                                required
                                :prop="'workHistory[' + $index + '].startTime'"
                            >
                                <el-date-picker
                                    type="month"
                                    v-model="work.startTime"
                                    value-format="yyyy-MM-dd"
                                    :title="work.startTime"
                                ></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                label="结束时间"
                                hidden-label
                                hiddenErrorText
                                required
                                :prop="'workHistory[' + $index + '].endTime'"
                            >
                                <el-date-picker
                                    type="month"
                                    v-model="work.endTime"
                                    value-format="yyyy-MM-dd"
                                    :title="work.endTime"
                                ></el-date-picker>
                            </el-form-item>
                        </td>
                        <td style="color:#C0C4CC">
                            {{month_between(work.startTime, work.endTime) }}
                        </td>
                        <td>
                            <el-form-item
                                label="工作单位"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 20 }"
                                :prop="'workHistory[' + $index + '].company'"
                            >
                                <el-input
                                    v-model="work.company"
                                    :title="work.company"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            <el-form-item
                                label="工作职位"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                :prop="'workHistory[' + $index + '].plant'"
                            >
                                <el-input
                                    v-model="work.plant"
                                    :title="work.plant"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td colspan="2">
                            <el-form-item
                                label="工作内容"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 50 }"
                                :prop="
                                    'workHistory[' + $index + '].workContent'
                                "
                            >
                                <el-input
                                    v-model="work.workContent"
                                    :title="work.workContent"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                label="工作状态"
                                hidden-label
                                hiddenErrorText
                                required
                                :prop="'workHistory[' + $index + '].status'"
                            >
                                <el-select v-model="work.status">
                                    <el-option
                                        label="至今在职"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="已离职"
                                        :value="2"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </td>

                        <td>
                            <el-form-item
                                label="证明人"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                :prop="'workHistory[' + $index + '].witness'"
                            >
                                <el-input
                                    v-model="work.witness"
                                    :title="work.witness"
                                ></el-input>
                            </el-form-item>
                        </td>

                        <td>
                            <el-form-item
                                label="证明人联系方式"
                                hidden-label
                                hiddenErrorText
                                :prop="
                                    'workHistory[' + $index + '].witnessPhone'
                                "
                                :rules="{ type: 'phone', max: 11 }"
                            >
                                <el-input
                                    v-model="work.witnessPhone"
                                    :title="work.witnessPhone"
                                ></el-input>
                                <span
                                    v-if="
                                        !disabled && info.workHistory.length > 0
                                    "
                                    class="removeRow"
                                    @click="removeRow($index, 'workHistory')"
                                    >移除</span
                                >
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            与应聘岗位相关的实践经历或取得的成绩
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="与应聘岗位相关的实践经历或取得的成绩"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 500 }"
                                prop="projectHistory"
                            >
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 4 }"
                                    v-model="info.projectHistory"
                                    :title="info.projectHistory"
                                    maxlength="500"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            自我评价
                        </td>
                        <td colspan="10">
                            <el-form-item
                                label="自我评价"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 400 }"
                                prop="selfAssessment"
                            >
                                <el-input
                                    type="textarea"
                                    rows="3"
                                    v-model="info.selfAssessment"
                                    :title="info.selfAssessment"
                                    maxlength="400"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td
                            :rowspan="info.familyMembers.length + 1"
                            class="addRowPanel"
                        >
                            <p>家庭成员及主要社会关系</p>
                            <p>(至少需要填写父母情况)</p>
                            <span
                                v-if="!disabled"
                                class="addRow"
                                @click="addRow('familyMembers')"
                                >增行</span
                            >
                        </td>
                        <td class="title" colspan="2">
                            称谓
                        </td>
                        <td colspan="2">
                            姓名
                        </td>
                        <td>
                            年龄
                        </td>
                        <td colspan="5">
                            现工作单位及职务
                        </td>
                    </tr>
                    <tr
                        v-for="(item, $index) in info.familyMembers"
                        class="eidtItem"
                    >
                        <td colspan="2">
                            <el-form-item
                                label="称谓"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                :prop="
                                    'familyMembers[' + $index + '].appellation'
                                "
                            >
                                <el-input
                                    v-model="item.appellation"
                                    :title="item.appellation"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td colspan="2">
                            <el-form-item
                                label="姓名"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 10 }"
                                :prop="'familyMembers[' + $index + '].fullName'"
                            >
                                <el-input
                                    v-model="item.fullName"
                                    :title="item.fullName"
                                ></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                label="年龄"
                                hidden-label
                                hiddenErrorText
                                :rules="{
                                    type: 'integer',
                                    max: 3,
                                    message:
                                        '正确的家庭成员及主要社会关系年龄(数字)',
                                }"
                                :prop="'familyMembers[' + $index + '].age'"
                            >
                                <el-input
                                    type="number"
                                    v-model="item.age"
                                    v-number-only
                                    :title="item.age"
                                ></el-input>
                                <!-- <el-date-picker
                  v-model="item.birthday"
                  value-format="yyyy-MM-dd"
                ></el-date-picker> -->
                            </el-form-item>
                        </td>
                        <td colspan="5">
                            <el-form-item
                                label="现工作单位及职务"
                                hidden-label
                                hiddenErrorText
                                required
                                :rules="{ max: 30 }"
                                :prop="
                                    'familyMembers[' +
                                        $index +
                                        '].companyAndPost'
                                "
                            >
                                <el-input
                                    v-model="item.companyAndPost"
                                    :title="item.companyAndPost"
                                ></el-input>
                                <span
                                    v-if="
                                        !disabled &&
                                            info.familyMembers.length > 2
                                    "
                                    class="removeRow"
                                    @click="removeRow($index, 'familyMembers')"
                                    >移除</span
                                >
                            </el-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td>备注</td>
                        <td colspan="10">
                            <el-form-item
                                label="备注"
                                hidden-label
                                hiddenErrorText
                                :rules="{ max: 200 }"
                            >
                                <el-input
                                    type="textarea"
                                    v-model="info.otherDescription"
                                    rows="2"
                                    :title="info.otherDescription"
                                    maxlength="200"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                        </td>
                    </tr>

                    <tr
                        v-for="(extraFiled, $index) in extraFields"
                        class="extraFields eidtItem"
                    >
                        <td>
                            {{ extraFiled.fieldName }}
                        </td>
                        <td colspan="10">
                            <el-form-item>
                                <el-input
                                    v-model="info.attr[extraFiled.fieldCode]"
                                ></el-input>
                                <span
                                    v-if="disabled && info.id == null"
                                    class="removeExtraFields"
                                    @click="removeFields(extraFiled.id, $index)"
                                    >移除</span
                                >
                            </el-form-item>
                        </td>
                    </tr>
                </tbody>
            </table>
        </el-form>
        <!-- 附件内容 -->
        <el-collapse
            accordion
            v-model="appendixCollapse"
            class="appendix active no-print"
        >
            <el-collapse-item
                title="报名所需资料上传"
                name="1"
                :class="appendixError ? 'showAppendixError' : ''"
            >
                <el-form
                    class="appendixForm"
                    label-width="100px"
                    ref="appendixForm"
                    :model="appendixInfo"
                >
                    <el-form-item label="身份证正面:" required prop="idFront">
                        <el-upload
                            with-credentials
                            :data="{ type: 6 }"
                            accept="image/*"
                            :action="uploadBaseUrl"
                            :on-success="uploadSetFields('idFront')"
                            :on-remove="uploadSetFields('idFront')"
                            :on-preview="viewFile"
                            list-type="picture-card"
                            :file-list="getFileList(appendixInfo.idFront)"
                            :class="{
                                emptyUpload:
                                    appendixInfo.idFront !== '' || disabled,
                            }"
                            :disabled="disabled"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="身份证反面:" required prop="idBack">
                        <el-upload
                            with-credentials
                            :data="{ type: 6 }"
                            accept="image/*"
                            :action="uploadBaseUrl"
                            :on-success="uploadSetFields('idBack')"
                            :on-remove="uploadSetFields('idBack')"
                            :on-preview="viewFile"
                            list-type="picture-card"
                            :file-list="getFileList(appendixInfo.idBack)"
                            :class="{
                                emptyUpload:
                                    appendixInfo.idBack !== '' || disabled,
                            }"
                            :disabled="disabled"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item
                        label="学历证书:"
                        prop="qualifications"
                        required
                    >
                        <el-upload
                            with-credentials
                            :data="{ type: 7 }"
                            accept="image/*"
                            :action="uploadBaseUrl"
                            :on-success="uploadSetFields('qualifications', 2)"
                            :on-remove="uploadSetFields('qualifications', 2)"
                            :on-preview="viewFile"
                            list-type="picture-card"
                            :file-list="
                                getFileList(appendixInfo.qualifications)
                            "
                            :class="{ emptyUpload: disabled }"
                            :disabled="disabled"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="资质证书:" prop="credentials">
                        <!-- <el-upload
              with-credentials
              :data="{type:8}"
              accept="image/*"
              :action="uploadBaseUrl"
              :on-success="uploadSetFields('credentials',2)"
              :on-remove="uploadSetFields('credentials',2)"
              :on-preview="handlePictureCardPreview"
              list-type="picture-card"
              :file-list="getFileList(appendixInfo.credentials)"
              :class="{'emptyUpload':disabled}"
              :disabled="disabled"
            >
              <i class="el-icon-plus"></i>

            </el-upload> -->

                        <el-upload
                            with-credentials
                            :data="{ type: 8 }"
                            :action="uploadBaseUrl"
                            :on-success="uploadSetFields('credentials', 2)"
                            :on-remove="uploadSetFields('credentials', 2)"
                            :on-preview="viewFile"
                            multiple
                            :file-list="getFileList(appendixInfo.credentials)"
                            :disabled="disabled"
                        >
                            <el-button
                                size="small"
                                type="primary"
                                :disabled="disabled"
                                >点击上传</el-button
                            >
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="其他资料:" prop="others">
                        <!-- <el-upload
              with-credentials
              :data="{type:9}"
              accept="image/*"
              :action="uploadBaseUrl"
              :on-success="uploadSetFields('others',2)"
              :on-remove="uploadSetFields('others',2)"
              :on-preview="handlePictureCardPreview"
              list-type="picture-card"
              :file-list="getFileList(appendixInfo.others)"
              :class="{'emptyUpload':disabled}"
              :disabled="disabled"
            >
              <i class="el-icon-plus"></i>

            </el-upload> -->

                        <el-upload
                            with-credentials
                            :data="{ type: 9 }"
                            :action="uploadBaseUrl"
                            :on-success="uploadSetFields('others', 2)"
                            :on-remove="uploadSetFields('others', 2)"
                            :on-preview="viewFile"
                            multiple
                            :file-list="getFileList(appendixInfo.others)"
                            :disabled="disabled"
                        >
                            <el-button
                                size="small"
                                type="primary"
                                :disabled="disabled"
                                >点击上传</el-button
                            >
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-collapse-item>
        </el-collapse>

        <div :class="[showAppendix ? 'active' : '', 'appendix']"></div>

        <el-dialog
            :visible.sync="dialogVisible"
            title="图片预览"
            :modal="false"
        >
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <c-print-template
            ref="registerFormRef"
            :info="info"
            :enrolInfo="enrolInfo"
            :extraFields="extraFields"
            :showInfo="startPrint"
        />
    </div>
</template>

<script>
import FileUrlMixin from '@/mixins/FileUrlMixin';
import { setTimeout } from 'timers';
import CPrintTemplate from '@/components/C-Register-Print-Template';
import { mapGetters } from 'vuex';

function MonthsBetw(date1, date2) {
    //用-分成数组
    date1 = date1.split('-');
    date2 = date2.split('-');
    //获取年,月数
    var year1 = parseInt(date1[0]),
        month1 = parseInt(date1[1]),
        year2 = parseInt(date2[0]),
        month2 = parseInt(date2[1]),
        //通过年,月差计算月份差
        months = (year2 - year1) * 12 + (month2 - month1) + 1;
    return months;
}

export default {
    components: { CPrintTemplate },
    mixins: [FileUrlMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        extraFields: {
            type: Array,
            default: () => {
                return [];
            },
        },
        enrolInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
        attachments: {
            type: Array,
            default: () => {
                return [];
            },
        }
    },
    data() {
        return {
            startPrint: false,
            appendixError: false,
            showAppendix: false,
            info: {
                fullName: '',
                gender: 1,
                nation: '',
                birthday: '',
                origo: '',
                birthPlace: '',
                domicilePlace: '',
                politicalStatus: '',
                idNumber: '',
                height: '',
                weight: '',
                health: '',
                photograph: '',
                firstQualifications: '',
                firstQualificationsProperty: 1,
                firstQualificationSchoolsAndMajors: '',
                firstQualificationGraduationTime: '',
                firstQualificationsPropertyDesc: '',
                highestQualification: '',
                highestQualificationsProperty: 1,
                highestQualificationSchoolsAndMajors: '',
                highestQualificationGraduationTime: '',
                highestQualificationsPropertyDesc: '',
                certificate: '',
                foreignLanguage: '',
                drivingLicense: 2,
                address: '',
                postCode: '',
                phone: '',
                email: '',
                otherLinkman: '',
                otherLinkmanPhone: '',
                workExperience: '',
                attr: {},
                workHistory: [
                    {
                        startTime: '',
                        endTime: '',
                        company: '',
                        plant: '',
                        workContent: '',
                        status: '',
                        witness: '',
                        witnessPhone: '',
                    },
                    {
                        startTime: '',
                        endTime: '',
                        company: '',
                        plant: '',
                        workContent: '',
                        status: '',
                        witness: '',
                        witnessPhone: '',
                    },
                    {
                        startTime: '',
                        endTime: '',
                        company: '',
                        plant: '',
                        workContent: '',
                        status: '',
                        witness: '',
                        witnessPhone: '',
                    },
                ],
                familyMembers: [
                    {
                        appellation: '',
                        fullName: '',
                        age: '',
                        companyAndPost: '',
                    },
                    {
                        appellation: '',
                        fullName: '',
                        age: '',
                        companyAndPost: '',
                    },
                    {
                        appellation: '',
                        fullName: '',
                        age: '',
                        companyAndPost: '',
                    },
                    {
                        appellation: '',
                        fullName: '',
                        age: '',
                        companyAndPost: '',
                    },
                ],
                projectHistory: '',
                selfAssessment: '',
                otherDescription: '',
            },
            appendixInfo: {
                //正面
                idFront: '',
                //反面
                idBack: '',
                //学历证书
                qualifications: [],
                //资质证书
                credentials: [],
                //其他资料
                others: [],
            },
            //附件手风琴
            appendixCollapse: [],
            //旋转角度
            rotateAngle: 0,
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'getUserRole', 'baseUserInfo']),
        valueIsNull: function() {
            return function(fieldCode) {
                return (
                    this.info.attr != null && this.info.attr[fieldCode] != null
                );
            };
        }
    },
    created() {
        this.setInitData();
    },
    methods: {
        toggleShowAppendix() {
            this.showAppendix = !this.showAppendix;
        },
        addRow(field) {
            var workHistoryObj = {
                startTime: '',
                endTime: '',
                company: '',
                plant: '',
                workContent: '',
                status: '',
                witness: '',
                witnessPhone: '',
            };

            var familyMembersObj = {
                appellation: '',
                fullName: '',
                age: '',
                companyAndPost: '',
            };
            var rowObj = {};
            if (field === 'workHistory') {
                rowObj = workHistoryObj;
            } else if (field === 'familyMembers') {
                rowObj = familyMembersObj;
            }

            var obj = this.info[field].push(rowObj);
        },
        removeRow(index, field) {
            this.info[field].splice(index, 1);
        },
        removeFields(id, index) {
            this.$emit('removeFileds', { id, index });
        },
        submit() {
            return new Promise((resolve, reject) => {
                var validFlag = true;
                var that = this;
                //基本信息校验
                this.$refs.signForm.validate((valid, errObj) => {
                    validFlag = valid;
                    if (valid) {
                        //附件表校验
                        this.$refs.appendixForm.validate((valid, errObj2) => {
                            validFlag = valid;
                            if (valid) {
                                //附件表转换成后台格式
                                var attachments = adapterToServerData(
                                    this.appendixInfo
                                );

                                //返回基本信息和附件信息
                                var data = {
                                    enrolInfo: this.info,
                                    attachments,
                                };
                                this.appendixError = false;
                                this.appendixCollapse = [];

                                resolve(data);
                            } else {
                                this.appendixError = true;
                                this.appendixCollapse = ['1'];

                                for (var i in errObj2) {
                                    that.$message.error(errObj2[i][0].message);
                                    break;
                                }
                            }
                        });
                    } else {
                        for (var i in errObj) {
                            console.log(i);
                            var emptyRow = false;
                            if (i.indexOf('workHistory') > -1) {
                                //工作经历空行判断
                                var workHistory = this.info.workHistory;
                                workHistory.forEach((work) => {
                                    var {
                                        startTime,
                                        endTime,
                                        company,
                                        plant,
                                        workContent,
                                        status,
                                        witness,
                                        witnessPhone,
                                    } = work;

                                    if (
                                        (startTime === '' ||
                                            startTime === null) &&
                                        (endTime === '' || endTime === null) &&
                                        company === '' &&
                                        plant === '' &&
                                        workContent === '' &&
                                        status === '' &&
                                        witness === '' &&
                                        witnessPhone === ''
                                    ) {
                                        emptyRow = true;
                                    }
                                });
                                if (emptyRow) {
                                    that.$message.error(
                                        '请先移除工作经历中的空白行!'
                                    );
                                    break;
                                }
                            } else if (i.indexOf('familyMembers') > -1) {
                                //家庭成员空行判断
                                var familyMembers = this.info.familyMembers;
                                familyMembers.forEach((members) => {
                                    var {
                                        appellation,
                                        fullName,
                                        age,
                                        companyAndPost,
                                    } = members;

                                    if (
                                        appellation === '' &&
                                        fullName === '' &&
                                        age === '' &&
                                        companyAndPost === ''
                                    ) {
                                        emptyRow = true;
                                    }
                                });
                                if (emptyRow && familyMembers.length > 2) {
                                    that.$message.error(
                                        '请先移除家庭成员中的空白行!'
                                    );
                                    break;
                                }
                            }
                            console.log(errObj[i]);
                            that.$message.error(errObj[i][0].message);
                            break;
                        }
                    }
                });
                // if (!validFlag) {
                //   this.$message.error('请检查内容和格式是正确(星号必填)!')
                // }
            });
        },
        uploadSetFields(fieldName, type = 1, obj = 'appendixInfo') {
            var that = this;
            return (uploadRes) => {
                if (uploadRes.code === 500) {
                    that.$message.error(uploadRes.message);
                    return;
                }

                var filePath =
                    uploadRes.data === undefined ? '' : uploadRes.data.filePath;
                if (type === 1) {
                    //字段类型的数据
                    that[obj][fieldName] = filePath;
                } else if (type === 2) {
                    //数组类型
                    if (filePath !== '') {
                        that[obj][fieldName].push(filePath);
                    } else {
                        //移除
                        filePath =
                            uploadRes.url || uploadRes.response.data.filePath;
                        var index = -1;
                        that[obj][fieldName].forEach((item, _index) => {
                            if (filePath.indexOf(item) > -1) {
                                index = _index;
                            }
                        });
                        if (index > -1) {
                            that[obj][fieldName].splice(index, 1);
                        }
                    }
                }
            };
        },
        //打印报名表
        print() {
            //显示下面的签名信息
            this.startPrint = true;
            setTimeout(() => {
                this.$print(this.$refs.registerFormRef);
                setTimeout(() => {
                    this.startPrint = false;
                }, 200);
            }, 200);
            // this.$alert("为保证打印质量,打印时请选择横向打印", "提示!", {
            //   confirmButtonText: "确定",
            //   type: "warning",
            //   showClose: false,
            //   callback: action => {
            //     //显示下面的签名信息
            //     this.startPrint = true;
            //     setTimeout(() => {
            //       this.$print(this.$refs.registerFormRef);
            //       setTimeout(() => {
            //         this.startPrint = false;
            //       }, 200);
            //     }, 200);
            //   }
            // });
        },
        setInitData() {
            //只有用户为考生时才赋值默认值
            if (this.getUserRole !== 1) {
                return;
            }
            //取默认值
            var { fullName, sex, idNumber } = this.userInfo;
            var { email } = this.baseUserInfo;
            console.log();
            if (this.info.fullName === '') {
                this.info.fullName = fullName;
                this.info.gender = sex;
                this.info.idNumber = idNumber;
                this.info.email = email;
            }
            if (idNumber) {
                var birthday = getBirthdayFromIdCard(idNumber);
                this.info.birthday = birthday;
            }
        },
        viewFile(file) {
            var { url } = file;
            //判断是否图片预览
            var type = url.substr(url.lastIndexOf('.'));
            console.log(type);
            if (
                undefined != type &&
                (type.toLowerCase() == '.jpg' ||
                    type.toLowerCase() == '.jpeg' ||
                    type.toLowerCase() == '.png' ||
                    type.toLowerCase() == '.gif')
            ) {
                window.open('#/imageview?img=' + file.url);
            } else {
                window.open(file.url);
            }
        },
        // 计算工作年限
        month_between(_startDate, _endDate) {
                if (_startDate && _endDate) {
                    let monthNumber = MonthsBetw(_startDate, _endDate);
                    if(monthNumber<0){
                      return '';
                    }
                    let yearNumber = parseFloat(monthNumber / 12).toFixed(1);
                    return `${yearNumber}年(${monthNumber}个月)`;
                }
                return '';
        },
    },
    directives: {
        numberOnly: {
            inserted: function(el) {
                el.addEventListener('keypress', function(e) {
                    e = e || window.event;
                    let charcode =
                        typeof e.charCode === 'number' ? e.charCode : e.keyCode;
                    let re = /\d/;
                    if (
                        !re.test(String.fromCharCode(charcode)) &&
                        charcode > 9 &&
                        !e.ctrlKey
                    ) {
                        if (e.preventDefault) {
                            e.preventDefault();
                        } else {
                            e.returnValue = false;
                        }
                    }
                });
            },
        },
    },
    watch: {
        enrolInfo(newVal) {
            var { height = '', weight = '', familyMembers = [], attr } = newVal;
            height = '' + height;
            weight = '' + weight;
            familyMembers = familyMembers.map((item) => {
                item.age = '' + item.age;
                return item;
            });
            this.info = newVal;
            this.info.height = height;
            this.info.weight = weight;
            this.info.familyMembers = familyMembers;
            this.info.attr = attr === null ? {} : attr;
        },
        attachments(newVal) {
            var appendixInfo = adapterServerDataToView(newVal);
            this.appendixInfo = appendixInfo;
        },
        extraFields(newVal) {
            var that = this;
            newVal.forEach((field) => {
                var code = field.fieldCode;
                that.$set(that.info.attr, code, this.info.attr[code]);
            });
        },
    },
};

//附件表转换成后台格式
var adapterToServerData = (appendixInfo) => {
    var list = [];
    for (var i in appendixInfo) {
        var data = {};
        switch (i) {
            case 'idFront':
                data = {
                    type: 1,
                    url: appendixInfo[i],
                };
                break;
            case 'idBack':
                data = {
                    type: 2,
                    url: appendixInfo[i],
                };
                break;
            case 'qualifications':
                data = [];
                appendixInfo[i].forEach((url) => {
                    data.push({
                        type: 3,
                        url,
                    });
                });
                break;
            case 'credentials':
                data = [];
                appendixInfo[i].forEach((url) => {
                    data.push({
                        type: 4,
                        url,
                    });
                });
                break;
            case 'others':
                data = [];
                appendixInfo[i].forEach((url) => {
                    data.push({
                        type: 5,
                        url,
                    });
                });
                break;
        }
        list = list.concat(data);
    }

    return list;
};

//附件表后台数据转换成前台数据
var adapterServerDataToView = (attachments) => {
    var data = {
        //正面
        idFront: '',
        //反面
        idBack: '',
        //学历证书
        qualifications: [],
        //资质证书
        credentials: [],
        //其他资料
        others: [],
    };
    attachments.forEach((item) => {
        var { type, url } = item;
        switch (type) {
            case 1:
                data.idFront = url;
                break;
            case 2:
                data.idBack = url;
                break;
            case 3:
                data.qualifications.push(url);
                break;
            case 4:
                data.credentials.push(url);
                break;
            case 5:
                data.others.push(url);
                break;
        }
    });
    return data;
};

//根据身份证计算出生年月
var getBirthdayFromIdCard = (idCard) => {
    var birthday = '';
    if (idCard != null && idCard != '') {
        if (idCard.length == 15) {
            birthday = '19' + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
            birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
    }

    return birthday;
};
</script>

<style lang="scss">
$table-border: #cac4c4;
.signTable {
    width: 100%;
    h3 {
        text-align: center;
    }
    table {
        text-align: center;
        z-index: 111;
        width: 100%;
        color: #827d7d;
        border-spacing: 0;
        border-right: 1px solid $table-border;
        border-bottom: 1px solid $table-border;
        td {
            border-left: 1px solid $table-border;
            border-top: 1px solid $table-border;
            position: relative;
        }
    }
    .el-form-item__content {
        margin: 0 !important;
    }
    .el-input,
    .el-select {
        width: 100%;
    }
    .el-form-item {
        margin-bottom: 0;
    }
    input,
    textarea {
        background-color: transparent;
        border: 0;
        border-radius: 0;
        resize: none;
    }
    .is-error input,
    .is-error textarea {
        // border-bottom: 1px solid #dcdfe6;
    }
    .is-disabled .el-input__inner,
    .is-disabled .el-textarea__inner {
        background-color: transparent;
    }
    .el-list-enter-active,
    .el-list-leave-active {
        transition: initial;
    }
    .is-error {
        &:before {
            content: '*';
            position: absolute;
            right: 6px;
            top: 50%;
            color: red;
            -webkit-transform: translateY(-36%);
            transform: translateY(-36%);
        }
    }
    .postName{
      margin:10px 0;
    }
}
td {
    height: 30px;
}
.addRowPanel:hover {
    .addRow {
        display: block;
    }
}
.addRow {
    // display: none;
    color: $main-color;
    text-decoration: underline;
    cursor: pointer;
    font-size: 12px;
}
.eidtItem td:last-child {
    position: relative;
}
.eidtItem:hover {
    .removeRow {
        display: inline-block;
    }
}
.removeRow {
    // display: none;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 40px;
    height: 40px;
    font-size: 12px;
    color: red;
    cursor: pointer;
    text-decoration: underline;
    // background: #f0f2f5;
}

.eidtItem:hover {
    .removeExtraFields {
        display: inline-block;
    }
}

.removeExtraFields {
    display: none;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 40px;
    height: 40px;
    font-size: 12px;
    color: red;
    cursor: pointer;
    text-decoration: underline;
    // background: #f0f2f5;
}

.bolder {
    font-weight: bolder;
    color: black;
}
.printInfo {
    height: 40px;
    div {
        display: flex;
        justify-content: space-around;
    }
}
.photograph {
    position: relative;
    width: 100%;
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-form-item__content,
    .el-upload {
        width: 100%;
        height: 100%;
    }
    i {
        margin-top: 50%;
        display: inline-block;
        line-height: 20px;
    }
    &.is-error::before {
        top: 56%;
        right: 0;
    }
}
.photograph-input {
    position: absolute;
    bottom: -2px;
    left: 0;
    z-index: 0;
}
.photograph-upload {
    z-index: 1;
    position: relative;
    width: 100%;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
        max-width: 150px;
    }
}

.appendix {
    text-align: left;
    p {
        font-weight: bold;
        span:first-of-type {
            color: red;
        }
        span:last-of-type {
            float: right;
            cursor: pointer;
            color: $main-color;
        }
    }
    &.active {
        height: auto;
        border-bottom: 0;
    }
    .el-form-item__label {
        text-align: left;
    }
    .el-form-item__content > div {
        display: inline-block;
        margin: 10px 0 20px 0;
    }
    .el-form-item__error {
        margin: -16px 0 !important;
    }
    .el-upload {
        margin-right: 10px;
    }
    .el-form-item__content {
        margin-left: 100px !important;
    }
    .uploadImg {
        border: 1px solid #e2dddd;
        width: 100px;
        height: 100px;
        display: inline-block;
        margin-right: 10px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
        line-height: 111px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap {
        background-color: transparent;
    }
    .el-collapse-item__header {
        font-weight: bold;
    }
    .showAppendixError {
        .el-collapse-item__header {
            &:before {
                content: '*';
                color: red;
                position: relative;
                margin-right: 6px;
            }
        }
    }
}
.emptyUpload {
    line-height: 0;
    position: relative;
    &:before {
        content: '\65E0';
        position: absolute;
        top: 0;
        margin-top: 10px;
    }
    .el-upload--picture-card {
        display: none;
    }
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
    margin-top: 67px;
}
</style>
